module.exports = __webpack_public_path__ + "static/media/profileAvatar.9d6cb060.svg";